import * as React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ChunkLoadBoundary from './components/ChunkLoadBoundary';

// Every page is a lazy chunk, so the main bundle holds only React and the router. The invite page in
// particular must not weigh on landing visitors (and the QR code is a further chunk inside it).
const LandingPage = React.lazy(() => import('./LandingPage'));
const PrivacyPolicy = React.lazy(() => import('./components/PrivacyPolicy'));
const TermsOfService = React.lazy(() => import('./components/TermsOfService'));
const PageNotFound = React.lazy(() => import('./components/PageNotFound'));
const DeepLinkRedirect = React.lazy(() => import('./components/DeepLinkRedirect'));
const InvitePage = React.lazy(() => import('./invite/InvitePage'));

export default function App() {
  return (
    <BrowserRouter>
      <ChunkLoadBoundary>
        <React.Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/quotes/:id" element={<DeepLinkRedirect />} />
            <Route path="/authors/:id" element={<DeepLinkRedirect />} />
            <Route path="/users/:id" element={<DeepLinkRedirect />} />
            <Route path="/books/:id" element={<DeepLinkRedirect />} />
            <Route path="/clubs/:clubId" element={<InvitePage />} />
            <Route path="/clubs/:clubId/events/:eventId" element={<InvitePage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </React.Suspense>
      </ChunkLoadBoundary>
    </BrowserRouter>
  );
}